var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"d-flex align-center justify-center py-6"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1):_c('router-view')
}
var staticRenderFns = []

export { render, staticRenderFns }